import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

export type TranslateTextLanguage = 'fr' | 'en' | 'es'

interface TranslateParams {
  text: string
  targetLanguage: TranslateTextLanguage
}

interface TranslateResponse {
  translatedText: string
}

const translateText = async (params: TranslateParams): Promise<TranslateResponse> => {
  const { data } = await api.post<TranslateResponse>('/ft_translate-text', params)
  return data
}

export const useFtTranslateText = () => {
  return useMutation<TranslateResponse, Error, TranslateParams>({
    mutationFn: translateText,
  })
}
